<template>
    <div v-if="hasMedia" :class="mediaClasses">
        <video v-if="hasVideoUrl" ref="$inlineVideo" class="page-media-video" :poster="posterUrl" playsinline loop muted preload="metadata">
            <source :src="videoSrc" type="video/mp4" />
        </video>
        <UiImage v-else :src="media[0].webp" :alt="media[0].title ?? ''" :classes="imageClasses" />
        <UiPlay v-if="hasVideoUrl" :poster="media" :video="video" :label="videoLabel" />
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        media?: CmsItem[];
        video?: CmsItem[];
        imageClasses?: string;
        wrapperClass?: string;
        videoLabel?: string;
    }>(),
    {
        media: () => [],
        video: () => [],
        imageClasses: 'responsive',
        wrapperClass: '',
        videoLabel: ''
    }
);

const media = computed(() => props.media ?? []);
const video = computed(() => props.video ?? []);

const hasMedia = computed(() => media.value.length > 0);
const videoSrc = computed(() => video.value[0]?.url ?? '');
const hasVideoUrl = computed(() => hasMedia.value && videoSrc.value.length > 0);
const posterUrl = computed(() => media.value[0]?.webp ?? '');

const mediaClasses = computed(() => ['page-media', props.wrapperClass].filter(Boolean));

const $inlineVideo = ref<HTMLVideoElement | null>(null);

useScrollVideo($inlineVideo);
</script>
